import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function ArrowDownLightIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Stroke 1"
        d="M12.2754 19.75V4.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Stroke 3"
        d="M18.299 13.6992L12.275 19.7492L6.25 13.6992"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
